import type { TFunction } from 'i18next';
import type { ScheduledChangeWorkingModeChange } from '@/common/api/models';

const ORAL_EXAM_IDS = new Set(['structure.oral_exam_present', 'structure.oral_exam_configured']);

/**
 * Maps stored working-mode change ids to lecturer-facing sentences; skips unknown ids.
 */
export function workingModeChangeLines(
  changes: ScheduledChangeWorkingModeChange[] | undefined,
  t: TFunction,
): string[] {
  if (!changes?.length) {
    return [];
  }
  const lines: string[] = [];
  let oralAdded = false;
  let essayAiCount = 0;
  changes.forEach((row) => {
    if (row.id === 'module.progression_gated') {
      lines.push(t('lecturer.scheduledChanges.workingMode.changes.progressionGated'));
      return;
    }
    if (ORAL_EXAM_IDS.has(row.id)) {
      if (!oralAdded) {
        lines.push(t('lecturer.scheduledChanges.workingMode.changes.oralExamAdded'));
        oralAdded = true;
      }
      return;
    }
    if (row.id === 'essay.ai_tutor_auto') {
      essayAiCount += 1;
    }
  });
  if (essayAiCount > 0) {
    lines.push(
      t('lecturer.scheduledChanges.workingMode.changes.aiTutorEssays', { count: essayAiCount }),
    );
  }
  return lines;
}
